import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';

import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasTkvV1Data } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';
import { buildTaasTkvV1DataForStrecke } from './transformer/tkvData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasTkvV1Data>;

export function* streckenTarifierungTkv(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    TkvActions.PREISE_REQUESTED,
    TkvActions.SELBSTBETEILIGUNG_CHANGED,
    TkvActions.HEILBEHANDLUNGSSCHUTZ_CHANGED,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.TKV,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_TKV,
    },
    buildTaasTkvV1DataForStrecke,
    undefined,
    createHashedRelevantRiskdataTKV,
  );

  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.TKV));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_TKV,
    safeSaga(streckenTarifierer.handleError, App.TKV),
  );
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.TKV));
}

export function createHashedRelevantRiskdataTKV(taasData: TaasTkvV1Data): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  delete relevantData.sublimit;

  return createHashedTaasData(relevantData);
}
